import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const CyberSafety = () => {
    useEffect(() => {
        document.title = 'Cyber Safety -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics  </li> 
                 <li>Cyber Safety</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Cyber Safety </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    <h6>GUIDANCE FOR CYBER SAFETY</h6>
                    <p><b>Dear Parents,</b></p> 
                    <p>Students can be caught by the same kinds of security problems that affect adults (drive-by downloads, links to malicious sites, viruses and malware, etc.). Also there are some special ways criminals get to kids, such as links to “fan sites” that contain malicious links or “free stuff,” messages that look like they're from friends, offers of free music or movies or ring tones or anything else that a student might be tempted to download.</p>
                  
                    <h6>CBSE Guidelines given below may be followed to protect personal information and computer online.</h6>
                   <ul className="list"> 
                  <li> Install and maintain up to date anti-virus software on your computer or device.</li>
                  <li> Keep your internet browser up-to-date</li>
                  <li> Be alert to unusual computer activity or problems.</li>
                  <li> Install and maintain a firewall on your computer.</li>
                  <li> Use a modern browser with features such as a pop-up blocker.</li>
                  <li> Avoid storing sensitive material indefinitely on your computer.</li>
                  <li> Change your passwords often.</li>
                  <li> Beware of links sent via instant messaging and e-mail attachments.</li>
                  </ul>
                   <ul className="list"> 
                  <h6>Important things to remember:</h6>
                  <li>Friendships made online are made by clicking a button rather than talking to people and sharing experiences. </li>
                  <li>Being online ‘friends’ with someone is much less meaningful than face to face friendship. </li>
                  <li>One can easily fall out with an online ‘friend’ because of a misunderstood comment. </li>
                  <li>It is far easier, and healthier, to sort out arguments and problems when one can talk to someone face to face </li>
                  </ul>
                  <h6>Tips to stay safe on social networking sites for students</h6>
                      <ul className="list"> 
                     <li> Make sure age appropriateness of an online activity before joining.
                     </li>
                     <li> May use a made up name or nickname on their profile.
                     </li>
                     <li> Not make friends other than persons known personally.
                     </li>
                     <li> May use an email address that does not include their name.
                     </li>
                     <li> Use the strongest privacy setting when setting up profile.
                     </li>
                     <li> This ensures that only desirable person will be able to view their information.
                     </li>
                     <li> Share pictures and videos very carefully when uploading, even with known persons, as it can easily be spread.
                     </li>
                     <li> Avoid illegal downloads.
                     </li>
                     <li> Avoid accessing internet games such as Blue Whale which is an Internet "game" that consists of a series of tasks assigned to players by administrators during a 50-day period, with the final challenge requiring the player to commit suicide. The term "Blue Whale" comes from the phenomenon of beached whales, which is linked to suicide. Please supervise your children and ensure that they are not downloading any such game.
                     </li>
                     <li> Rather encourage your children to play outdoor games and develop hobbies like book reading etc so that they utilize their time gainfully.</li>
                  </ul>
                  <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/CyberSafetyRules.pdf" target="_blank"><b><u>Cyber Safety Rules</u></b></Link>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default CyberSafety